import React from 'react';
import moment from 'moment';
import cn from 'classnames';

import './DateLabel.css';

export type dateLabelProps = {
  date: any
  className?: string
  type?: 'tiny' | 'small' | 'medium' | 'large'
  dateVal?: any
  testId?: string
};

const DateLabel = (props: dateLabelProps) => {

  let { date, className, type = "tiny", dateVal, testId = "cs-date-label" } = props;

  if (typeof (date) === 'number') {
    date = date.toString();
  };

  const typeClass = `DateLabel--${type}`;
  const classNames = cn('DateLabel', typeClass, className);

  // console.log('dateTime publishDetails datelabel', dateVal, moment(dateVal).format('MMM DD, YYYY [ ]hh:mm A'), '==>', date, moment(date).format('MMM DD, YYYY [ ]hh:mm A'));

  return (
    <div className={classNames} data-test-id={testId}>
      {moment(date).format('MMM DD, YYYY [ ]hh:mm A')}
    </div>
  );
};

export default DateLabel;